export const enTranslations: Record<string, string> = {
  nav_home: 'Home',
  nav_catalog: 'Catalog',
  nav_build: 'Build your PC',
  nav_services: 'Services',
  nav_about: 'About Us',
  nav_book: 'Book Appointment',
  theme_dark: 'Dark Mode',
  theme_light: 'Light Mode',
  theme_light_btn: 'Light',
  theme_dark_btn: 'Dark',
  cart: 'Cart',
  add_to_cart: 'Add to cart',
  view_catalog: 'View Catalog',
  contact_us: 'Contact Us',
  send: 'Send',
  loading: 'Loading...',
  search: 'Search...',
  close: 'Close',
  unit_short: 'units',
  hero_eyebrow: 'Santo Domingo, Dominican Republic',
  hero_title1: 'Level Up',
  hero_title2: 'Your Experience',
  hero_subtitle: 'Premium gaming hardware · Custom builds · Enterprise solutions',
  hero_cta1: 'View Catalog',
  hero_cta2: 'Request Quote',
  hero_scroll: 'Scroll',
  stat_clients: 'Satisfied clients',
  stat_products: 'Products in catalog',
  stat_years: 'Years of experience',
  stat_rating: 'Average rating',
  new_badge: 'New Stock',
  new_title: 'New Arrivals',
  new_subtitle: 'Freshly stocked gaming components and peripherals',
  new_cta: 'View Full Catalog',
  builder_badge: 'Configurator',
  builder_title: 'Build Your PC',
  builder_title_accent: 'your way',
  builder_subtitle: 'Pick each component, check real-time compatibility, and get your quote in seconds.',
  builder_cta: 'Start Building',
  services_badge: 'What we do',
  services_title: 'SpartechRD',
  services_title_accent: 'Services',
  services_subtitle: 'Complete solutions for hardware, software and technical support',
  about_badge: 'Our story',
  about_title: 'About',
  about_title_accent: 'Us',
  contact_badge: 'Get in touch',
  contact_title: 'Contact Us',
  contact_subtitle: "We're here to help with any questions about hardware, services or quotes",
  contact_name: 'Name',
  contact_email: 'Email Address',
  contact_phone: 'Phone',
  contact_message: 'Message',
  contact_send: 'Send Message',
  footer_about: 'Your tech ally in the DR since 2013. Gaming hardware, custom builds and professional tech support in Santo Domingo Este.',
  footer_nav: 'Navigation',
  footer_contact: 'Contact',
  footer_location: 'Location & Hours',
  footer_rights: 'All rights reserved.',
  footer_system: 'System Online',
  footer_mon_fri: 'Mon – Sat',
  footer_sat: 'Saturday',
  footer_sun: 'Sunday',
  footer_closed: 'Closed',
  book_title: 'Book Your',
  book_title_accent: 'Visit',
  book_subtitle: 'Pick a date and time for one of our certified technicians to assist you',
  catalog_title: 'Our',
  catalog_title_accent: 'Catalog',
  catalog_search: 'Search products...',
  catalog_filter: 'Filter',
  catalog_sort: 'Sort',
  catalog_all: 'All',
  catalog_showing: 'Showing',
  catalog_of: 'of',
  catalog_products: 'products',
  product_add_cart: 'Add to cart',
  product_quote_wa: 'Quote via WhatsApp',
  product_specs: 'Specifications',
  product_in_stock: 'In stock',
  product_out_stock: 'Out of stock',
  cart_title: 'Your Cart',
  cart_empty: 'Your cart is empty',
  cart_total: 'Total',
  cart_checkout: 'Checkout via WhatsApp',
  cart_clear: 'Clear cart',
  tracking_title: 'Equipment',
  tracking_accent: 'Tracking',
  tracking_subtitle: 'Enter your ticket number to check your equipment status',
  tracking_placeholder: 'E.g.: SPT-12345',
  tracking_search_btn: 'Search',
  faq_badge: 'Frequently asked questions',
  faq_title_1: 'Everything you',
  faq_title_2: 'need to know',
  faq_subtitle: 'We answer your questions about purchases, shipping, warranties, builds and more.',
  faq_more: 'Another question?',
  faq_q1: 'Do you ship across the Dominican Republic?',
  faq_a1: 'Yes, we ship nationwide. We work with reliable couriers and you can choose standard delivery (2-5 days) or express (1-2 days). Orders over RD$5,000 get free shipping within Greater Santo Domingo.',
  faq_q2: 'Do products come with a warranty?',
  faq_a2: "All our products include the official manufacturer's warranty. GPUs and CPUs have 1-3 years, RAM and SSDs 3-5 years, and peripherals 1-2 years. Custom builds also include an additional 1-year SpartechRD warranty.",
  faq_q3: 'Can I pay in installments?',
  faq_a3: 'Yes, we accept installment payments through major Dominican banks. You can finance your purchase in 3, 6 or 12 months with credit cards. We also offer corporate plans for businesses needing large quantities.',
  faq_q4: 'How long does a custom build take?',
  faq_a4: 'Build time varies by complexity and component availability. Generally, a full build takes 3-7 business days. We include 24-hour stress testing before delivering any assembled PC.',
  faq_q5: 'Do you offer tech support and repairs?',
  faq_a5: 'We have a certified tech team for diagnostics, repairs and maintenance. We offer on-site service for corporate clients in Santo Domingo and accept equipment for in-shop repairs. Repair estimates are free with no obligation.',
  faq_q6: 'Can I visit the physical store?',
  faq_a6: "Absolutely. Our store is located at C/Octavio Mejía Ricart Esq. C/Aruba #18A, Ensanche Ozama, Santo Domingo Este. Open Monday to Saturday 9:00 AM to 6:00 PM. Sundays and holidays closed. We recommend calling ahead if you want personalized advice.",
  faq_q7: 'Do you accept returns or exchanges?',
  faq_a7: 'We accept returns within the first 7 days for factory defects or non-functioning products. Personal preference exchanges can be made within the first 3 days if the product is unopened.',
  faq_q8: 'Do you work with businesses and corporations?',
  faq_a8: 'Yes, we have a specialized corporate division. We offer volume pricing, periodic maintenance plans, official tax invoicing (NCF), and can design complete tech solutions for businesses of any size.',
  reviews_title: 'Our',
  reviews_accent: 'Clients',
  reviews_subtitle: 'Real opinions from those who already leveled up',
  new_label: 'Just arrived',
  new_heading1: 'The Latest',
  new_heading2: 'Stock',
  new_see_all: 'View full catalog',
  new_add_cart: 'Add to cart',
  new_in_stock: 'In stock',
  new_out_stock: 'Out of stock',
  new_on_request: 'On request',
  builder_new_label: 'New',
  builder_teaser_title1: 'Configure your',
  builder_teaser_title2: 'Ideal PC',
  builder_teaser_body: 'Use our step-by-step configurator to build the perfect PC for gaming, creative work or office. Real-time compatibility check and direct quote.',
  builder_compat: 'Automatic compatibility',
  builder_realtime: 'Real-time pricing',
  builder_assembly: 'Professional assembly',
  builder_wa_quote: 'WhatsApp quote',
  builder_step_cpu: 'Choose your CPU',
  builder_step_mobo: 'Motherboard',
  builder_step_ramgpu: 'RAM & GPU',
  builder_step_quote: 'Instant quote',
  builder_start: 'Start Configuring',
  contact_heading1: "Let's talk about your",
  contact_heading2: 'next setup',
  contact_body: 'Our team is ready to advise you on component purchases, custom builds or tech solutions for your business.',
  contact_phone_label: 'Phone',
  contact_location_label: 'Location',
  contact_hours_label: 'Hours',
  contact_wa_label: 'WhatsApp',
  contact_wa_cta: 'Chat with an agent →',
  contact_hours_val: 'Mon – Sat: 9:00 AM – 6:00 PM',
  contact_hours_closed: 'Sundays & holidays: Closed',
  contact_location_val: 'C/Octavio Mejía Ricart Esq. C/ Aruba #18A, Ens. Ozama, Santo Domingo Este, DR',
  contact_form_title: 'Send us a message',
  contact_subject_label: 'Subject',
  contact_send_btn: 'Send Message',
  contact_sending: 'Sending...',
  contact_success_title: 'Message sent!',
  contact_success_desc: "We'll be in touch shortly. Thank you!",
  contact_another: 'Send another message',
  contact_error: 'There was an error sending. Please try again.',
  contact_disclaimer: 'By submitting you agree that a SpartechRD technician will contact you to coordinate the service.',
  tracking_notify_title: 'Get notified',
  tracking_notify_desc: "We'll alert you when your ticket status changes",
  tracking_notify_wa: 'Notify me via WhatsApp',
  tracking_notify_email_ph: 'your@email.com',
  tracking_notify_email_btn: 'Subscribe',
  tracking_notify_success: "Done! We'll notify you when we detect changes to your ticket.",
  tracking_notify_or: 'or',
  latest_badge: 'Just arrived',
  latest_title1: 'Latest',
  latest_title2: 'Products',
  latest_subtitle: 'Discover high-performance hardware to take your setup to the next level',
  latest_view_catalog: 'View in Catalog',
  latest_view_all: 'View full catalog',
  svc_hero_badge: 'Professional Services',
  svc_hero_title1: 'Elite',
  svc_hero_title2: 'Technical',
  svc_hero_title3: 'Solutions',
  svc_hero_subtitle: 'Custom builds, preventive maintenance and specialized tech support in Santo Domingo. Over 10 years solving hardware and software problems.',
  svc_hero_cta1: 'Request Service',
  svc_hero_cta2: 'Talk to a Technician',
  svc_stat_built: 'PCs assembled',
  svc_stat_time: 'Average turnaround',
  svc_stat_warranty: 'Warranty included',
  svc_stat_warranty_val: '1 year',
  svc_stat_rating: 'Satisfied clients',
  svc_pkg_badge: 'Our Services',
  svc_pkg_title: 'Choose Your',
  svc_pkg_title_accent: 'Plan',
  svc_pkg_subtitle: 'Plans designed for every need, from individual users to businesses.',
  svc_tab_assembly: 'Assembly',
  svc_tab_maintenance: 'Maintenance',
  svc_tab_support: 'Tech Support',
  svc_specialized: 'Specialized service',
  svc_process_badge: 'Process',
  svc_process_title: 'How We',
  svc_process_title_accent: 'Work',
  svc_process_subtitle: 'Clear and transparent process from start to finish',
  svc_step1_title: 'Request the Service',
  svc_step1_desc: 'Fill out the form with the service type, equipment description and your availability.',
  svc_step1_detail: 'Response in less than 2 hours during business hours.',
  svc_step2_title: 'Diagnosis & Quote',
  svc_step2_desc: 'Our technician evaluates the case and sends you a detailed no-obligation quote.',
  svc_step2_detail: 'The on-site diagnosis costs RD$500, which is deducted from the service.',
  svc_step3_title: 'Work Execution',
  svc_step3_desc: 'With your approval, the technician performs the service to the highest quality standards.',
  svc_step3_detail: 'Estimated time informed before starting. Real-time updates.',
  svc_step4_title: 'Delivery & Warranty',
  svc_step4_desc: 'Receive your fully working equipment with a technical report and documented warranty.',
  svc_step4_detail: 'Warranty of 30 to 90 days depending on the type of service performed.',
  svc_g1_title: 'Response in 2h',
  svc_g1_desc: 'Confirmation of your request during business hours',
  svc_g2_title: 'Certified Technicians',
  svc_g2_desc: 'Staff with 5+ years of proven experience',
  svc_g3_title: 'Data Protected',
  svc_g3_desc: 'Strict confidentiality policy on all work',
  svc_g4_title: 'Satisfaction Guaranteed',
  svc_g4_desc: "If you're not satisfied, we'll fix it at no extra cost",
  svc_form_badge: 'Request Form',
  svc_form_title: 'Request Your',
  svc_form_title_accent: 'Service',
  svc_form_subtitle: 'Fill out the form and a specialized technician will contact you within 2 hours during business hours.',
  svc_form_contact_ch: 'Contact Channels',
  svc_form_hours: 'Business Hours',
  svc_form_h1: 'Monday – Saturday',
  svc_form_t1: '9:00 AM – 6:00 PM',
  svc_form_h2: 'Sunday & holidays',
  svc_form_t2: 'Closed',
  svc_form_h3: '',
  svc_form_t3: '',
  svc_form_heading: 'Request Details',
  svc_form_name: 'Name',
  svc_form_name_ph: 'Your full name',
  svc_form_email: 'Email',
  svc_form_phone: 'Phone',
  svc_form_phone_ph: '(809) 000-0000',
  svc_form_company: 'Company',
  svc_form_company_ph: 'Optional',
  svc_form_service: 'Service Type',
  svc_form_service_ph: 'Select...',
  svc_form_service_1: 'PC Assembly',
  svc_form_service_2: 'Preventive Maintenance',
  svc_form_service_3: 'Remote Tech Support',
  svc_form_service_4: 'On-site Tech Support',
  svc_form_service_5: 'Enterprise SLA Plan',
  svc_form_service_6: 'Maintenance Contract',
  svc_form_service_7: 'Other',
  svc_form_plan: 'Plan / Modality',
  svc_form_plan_ph: 'No preference',
  svc_form_plan_1: 'Basic',
  svc_form_plan_2: 'Pro / Complete',
  svc_form_plan_3: 'Enterprise / Contract',
  svc_form_qty: 'Number of Devices',
  svc_form_qty_1: '1 device',
  svc_form_qty_2: '2 – 5 devices',
  svc_form_qty_3: '6 – 20 devices',
  svc_form_qty_4: '21 – 50 devices',
  svc_form_qty_5: 'More than 50',
  svc_form_urgency: 'Urgency',
  svc_form_urgency_1: 'Normal (1-3 days)',
  svc_form_urgency_2: 'Urgent (same day)',
  svc_form_urgency_3: 'Schedule date',
  svc_form_location: 'Location / Area',
  svc_form_location_ph: 'E.g.: Santo Domingo Este, Los Minas...',
  svc_form_desc: 'Problem / Requirement Description',
  svc_form_desc_ph: 'Describe the problem, symptoms, affected equipment, or what you need done...',
  svc_form_pref: 'Contact Preference',
  svc_form_pref_call: 'Call',
  svc_form_submit: 'Submit Service Request',
  svc_form_submitting: 'Sending...',
  svc_form_success_title: 'Request Sent!',
  svc_form_success_desc: 'A technician will review your request and contact you within 2 hours during business hours.',
  svc_form_success_wa: 'Confirm via WhatsApp',
  svc_form_another: 'Submit another request',
  svc_form_error: 'Error sending. Please try again.',
  svc_form_disclaimer: 'By submitting you agree that a SpartechRD technician will contact you to coordinate the service.',
  news_section_badge: 'Stay Updated',
  news_section_title: 'Gaming &',
  news_section_title_accent: 'Tech News',
  news_section_subtitle: 'The latest in hardware, gaming and tech that directly impacts what we sell',
  news_read_more: 'Read more',
  news_read_time: 'read',
  cat_all: 'All',
  cat_gpu: 'Graphics Cards',
  cat_cpu: 'Processors',
  cat_ram: 'RAM Memory',
  cat_storage: 'Storage',
  cat_chairs: 'Gaming Chairs',
  cat_monitors: 'Monitors',
  cat_accessories: 'Accessories',
  cat_builds: 'Custom Builds',
  product_no_stock_btn: 'Out of stock',
  product_add_cart_btn: 'Add to cart',
  product_view_detail: 'Details',
  product_featured_badge: 'Featured',
  product_on_request: 'On request',
  product_add_compare_tip: 'Add to compare',
  product_in_compare_label: 'Comparing',
  product_cat_gpu: 'Graphics Card',
  product_cat_cpu: 'Processor',
  product_cat_ram: 'RAM Memory',
  product_cat_storage: 'Storage',
  product_cat_chairs: 'Gaming Chair',
  product_cat_monitors: 'Monitor',
  product_cat_accessories: 'Accessory',
  product_cat_builds: 'Custom Build',
  catalog_hero_badge: 'SpartechRDRD',
  catalog_hero_title: 'Full',
  catalog_hero_title_accent: 'Catalog',
  catalog_hero_subtitle: 'Gaming hardware, chairs, monitors and custom builds — updated in real time',
  catalog_sort_relevance: 'Relevance',
  catalog_sort_price_asc: 'Price: low to high',
  catalog_sort_price_desc: 'Price: high to low',
  catalog_sort_name: 'Name A-Z',
  catalog_result_loading: 'Loading products...',
  catalog_result_of_label: 'of',
  catalog_live_label: 'Live',
  catalog_updated_label: 'Upd.',
  catalog_no_match: 'No products match this filter',
  catalog_no_match_sub: 'Try other keywords or clear the filters',
  catalog_clear_filters: 'Clear filters',
  catalog_retry: 'Retry',
  catalog_error_msg: 'Error loading products',
  catalog_unit: 'product',
  catalog_units: 'products',
  arma_badge: 'Real-Time Configurator',
  arma_title1: 'Build Your',
  arma_title2: 'Perfect PC',
  arma_subtitle: 'Choose each component step by step. Automatic compatibility, real-time pricing, direct quote.',
  arma_preset_popular: 'Popular',
  arma_preset_selected: 'Selected',
  arma_preset1_name: 'Basic Gaming PC',
  arma_preset2_name: 'Creative Workstation',
  arma_preset3_name: 'Ultra Gaming 4K PC',
  arma_preset4_name: 'Pro Office PC',
  arma_search_ph: 'Search component...',
  arma_sort_perf: 'Performance',
  arma_sort_price: 'Price ↑',
  arma_sort_rating: 'Rating',
  arma_compat_toggle: 'Compatible only',
  arma_step_label: 'Step',
  arma_step_of: 'of',
  arma_prev: 'Previous',
  arma_next: 'Next',
  arma_no_compat: 'No compatible components found',
  arma_show_all: 'Show all',
  arma_realtime_badge: 'Real-Time Configurator',
  arma_why_title: 'Why build with',
  arma_why_brand: 'SpartechRD',
  arma_why_f1_title: 'Professional Assembly',
  arma_why_f1_desc: 'Certified technicians with 10+ years of experience',
  arma_why_f2_title: '1-Year Warranty',
  arma_why_f2_desc: 'Full coverage on parts and labor',
  arma_why_f3_title: 'After-Sales Support',
  arma_why_f3_desc: 'Remote and on-site technical assistance',
  arma_why_f4_title: '48h Delivery',
  arma_why_f4_desc: 'Nationwide shipping and Santo Domingo delivery',
  build_sum_title: 'Your Build',
  build_sum_components: 'components',
  build_sum_ready: 'ready',
  build_sum_none: 'Not selected',
  build_sum_perf: 'Estimated Performance',
  build_sum_value: 'Value Ratio',
  build_sum_watt: 'Estimated usage',
  build_sum_psu_warn: '⚠ Insufficient PSU',
  build_sum_total: 'Estimated total',
  build_sum_preview: 'Preview Build',
  build_sum_wa: 'Quote via WhatsApp',
  build_sum_clear: 'Clear build',
  build_sum_selected: '✓ Selected',
  seg_hero_badge: 'Ticket Tracking',
  seg_hero_title: 'Track your',
  seg_hero_title_accent: 'Service',
  seg_hero_subtitle: 'Enter your ticket number to see the current status of your equipment.',
  seg_ticket_note: 'Your ticket number was sent to your email and WhatsApp when booking your appointment.',
  seg_search_btn: 'Search',
  seg_demo_note: 'Demo tickets available:',
  seg_not_found_title: 'Ticket not found',
  seg_not_found_sub: "We couldn't find ticket",
  seg_wa_consult: 'Check via WhatsApp',
  seg_result_client: 'Client',
  seg_result_received_label: 'Received:',
  seg_result_view_full: 'View Full Details',
  seg_status_title: 'Service Status',
  seg_in_progress_badge: 'In Progress',
  seg_completed_badge: '✓ Completed',
  seg_tech_label: 'Assigned Technician',
  seg_tech_note_label: "Technician's Note",
  seg_ready_title: 'Your equipment is ready!',
  seg_ready_desc: 'You can pick it up at our location in Santo Domingo Este.',
  seg_ready_wa: 'Arrange Delivery',
  seg_questions: 'Questions about your service?',
  seg_ask_ticket: 'Ask about my ticket',
  seg_wa_ask: 'Ask via WhatsApp',
  seg_step1_label: 'Received',
  seg_step1_desc: 'Equipment received at store',
  seg_step2_label: 'In Diagnosis',
  seg_step2_desc: 'Technician evaluating equipment',
  seg_step3_label: 'In Repair',
  seg_step3_desc: 'Work in progress',
  seg_step4_label: 'Quality Testing',
  seg_step4_desc: 'Verifying functionality',
  seg_step5_label: 'Ready for Pickup',
  seg_step5_desc: 'You can pick up your equipment',
  seg_modal_title: 'Order Details',
  seg_modal_service: 'Service',
  seg_modal_device: 'Device',
  seg_modal_client: 'Client',
  seg_modal_date: 'Date Received',
  seg_modal_current: 'Current Status',
  seg_modal_progress: 'Service Progress',
  seg_modal_wa: 'Ask via WhatsApp',
  seg_modal_close: 'Close',
  seg_modal_ready: 'Ready for pickup!',
  seg_modal_ready_desc: 'Your equipment is ready to be picked up at our store.',
  comp_perf: 'Performance',
  comp_available: 'avail.',
  comp_out_stock: 'Out of stock',
  stories_badge: 'Success Stories',
  stories_title1: 'Companies that Trust',
  stories_title2: 'SpartechRD',
  stories_sub: 'From construction to national security — leading brands in the Dominican Republic choose SpartechRDRD for their tech infrastructure.',
  stories_paused: 'Paused',
  step_cpu_label: 'Processor',
  step_cpu_desc: 'The brain of your PC',
  step_motherboard_label: 'Motherboard',
  step_motherboard_desc: 'The base that connects everything',
  step_ram_label: 'RAM Memory',
  step_ram_desc: 'Speed and multitasking',
  step_gpu_label: 'Graphics Card',
  step_gpu_desc: 'Visual power and gaming',
  step_storage_label: 'Storage',
  step_storage_desc: 'Load speed and space',
  step_psu_label: 'Power Supply',
  step_psu_desc: 'Stable and efficient power',
  step_case_label: 'Case',
  step_case_desc: 'Style and airflow',
  step_cooling_label: 'Cooling',
  step_cooling_desc: 'Temperatures under control',
  nos_hero_badge: 'Our Story',
  nos_hero_title_pre: 'Over 10 Years',
  nos_hero_title_hl: 'transforming',
  nos_hero_title_post: 'technology in the DR',
  nos_hero_sub: 'We are the technology partner for businesses and gamers in the Dominican Republic since 2013. Building lasting relationships based on trust, quality and passion for technology.',
  nos_stat1_v: '10+',
  nos_stat1_l: 'Years of experience',
  nos_stat2_v: '500+',
  nos_stat2_l: 'Satisfied clients',
  nos_stat3_v: '3,500+',
  nos_stat3_l: 'Devices serviced',
  nos_stat4_v: '4.9',
  nos_stat4_l: 'Average rating',
  nos_mission_title: 'Mission',
  nos_mission_desc: 'To provide quality technology hardware and specialized technical services that transform the digital experience of our clients, with transparency and excellence in every project.',
  nos_vision_title: 'Vision',
  nos_vision_desc: 'To be the reference technology company in the Dominican Republic, recognized for the quality of our products, the excellence of our team, and our positive impact on the local tech community.',
  nos_purpose_title: 'Purpose',
  nos_purpose_desc: 'To democratize access to high-performance technology in the Dominican Republic, providing expert advice and quality products at fair prices.',
  nos_val1: 'Excellence',
  nos_val1_desc: 'We accept no mediocrity in any service or product',
  nos_val2: 'Honesty',
  nos_val2_desc: 'Full transparency with every client, always',
  nos_val3: 'Innovation',
  nos_val3_desc: 'Always at the forefront of technology',
  nos_val4: 'Community',
  nos_val4_desc: 'Building the Dominican tech ecosystem',
  nos_tl1_year: '2013',
  nos_tl1_title: 'SpartechRD Founded',
  nos_tl1_desc: 'We started operations in Santo Domingo Este with a small computer repair workshop.',
  nos_tl2_year: '2015',
  nos_tl2_title: 'First Physical Store',
  nos_tl2_desc: 'We opened our first commercial location in Ensanche Ozama, expanding our hardware catalog.',
  nos_tl3_year: '2017',
  nos_tl3_title: 'Gaming Specialization',
  nos_tl3_desc: 'We positioned ourselves as gaming hardware leaders in Santo Domingo, attracting the local gamer community.',
  nos_tl4_year: '2019',
  nos_tl4_title: 'Business Expansion',
  nos_tl4_desc: 'We launched enterprise solutions: maintenance contracts, network installations and SLA support.',
  nos_tl5_year: '2021',
  nos_tl5_title: 'E-Commerce Platform',
  nos_tl5_desc: 'We launched our online store enabling purchases and quotes from all over the Dominican Republic.',
  nos_tl6_year: '2023',
  nos_tl6_title: '10 Years & Recognition',
  nos_tl6_desc: 'We celebrated a decade of operations with over 200 business clients and 3,500 devices serviced.',
  nos_member1_name: 'Carlos Martínez',
  nos_member1_role: 'CEO & Founder',
  nos_member1_desc: 'Over 15 years in the tech sector. Visionary of gaming hardware in the DR.',
  nos_member2_name: 'Luis Rodríguez',
  nos_member2_role: 'Head Technician',
  nos_member2_desc: 'Specialist in high-performance builds and overclocking. A+ Certified.',
  nos_member3_name: 'Ana García',
  nos_member3_role: 'Sales Manager',
  nos_member3_desc: 'Expert in enterprise solutions and corporate client relations.',
  nos_member4_name: 'Miguel Santos',
  nos_member4_role: 'Senior Technician',
  nos_member4_desc: 'Specialized in laptop repair, advanced diagnostics and technical support.',
  nos_co1_name: 'Constructora Sanval',
  nos_co1_sector: 'Construction',
  nos_co1_desc: 'We equipped their offices with high-performance workstations for project management.',
  nos_co2_name: 'Blink Gaming',
  nos_co2_sector: 'Entertainment',
  nos_co2_desc: 'We supply gaming hardware for their tournaments and gaming halls in Santo Domingo.',
  nos_co3_name: 'Alofoke Media',
  nos_co3_sector: 'Media & Streaming',
  nos_co3_desc: 'We set up their editing and streaming stations with professional latest-gen components.',
  nos_co4_name: '9-1-1 Emergency',
  nos_co4_sector: 'National Security',
  nos_co4_desc: 'Critical tech infrastructure for the national emergency response system of the DR.',
  nos_timeline_badge: 'Our Journey',
  nos_timeline_title1: 'History of',
  nos_timeline_title2: 'SpartechRD',
  nos_team_badge: 'The team behind',
  nos_team_title1: 'Our',
  nos_team_title2: 'Team',
  nos_co_badge: 'Corporate clients',
  nos_co_title1: 'Companies that',
  nos_co_title2: 'Trust',
  nos_co_title3: 'Us',
  nos_cta_title1: 'Ready for the',
  nos_cta_title2: 'next level?',
  nos_cta_sub: "Book a visit, quote your ideal PC or just message us on WhatsApp. We're here to transform your tech experience.",
  nos_cta_btn1: 'Book Appointment',
  nos_cta_btn2: 'Message on WhatsApp',
  svc_exp_badge: 'Our Experience',
  svc_exp_title1: 'Over',
  svc_exp_title2: '10 Years',
  svc_exp_title3: 'solving technology problems',
  svc_exp_desc: 'SpartechRD has been the technology partner for businesses and individuals in the Dominican Republic for over a decade. Our technicians are continuously updated with the latest market technologies.',
  svc_exp_stat1_l: 'Companies served',
  svc_exp_stat2_l: 'Devices repaired',
  svc_exp_stat3_l: 'PCs assembled',
  svc_exp_stat4_l: 'Average rating',
  svc_faq_section_badge: 'FAQ',
  svc_faq_section_title: 'Frequently Asked Questions',
  svc_faq_q1: 'How long does a professional assembly take?',
  svc_faq_a1: 'A Pro assembly takes between 24 and 48 hours. If components are provided by the client, we can have it ready the same day in some cases.',
  svc_faq_q2: 'Do you offer on-site service?',
  svc_faq_a2: 'Yes, our on-site tech support plan includes a visit to your location in Santo Domingo and surroundings. Areas outside Greater Santo Domingo may incur an additional travel fee.',
  svc_faq_q3: 'What does the service warranty include?',
  svc_faq_a3: 'The warranty covers labor for the work performed (30 to 90 days depending on the plan). New components come with additional manufacturer warranty.',
  svc_faq_q4: 'Can you service branded equipment like HP, Dell, Lenovo?',
  svc_faq_a4: 'Absolutely. We service equipment of all brands, both desktops and laptops, for personal and business use.',
  svc_faq_q5: 'How does remote support work?',
  svc_faq_a5: 'We use secure tools like TeamViewer or AnyDesk. Just download the software, share the access code with our technician, and they can resolve the problem from our office.',
  svc_asm_title: 'PC Assembly',
  svc_asm_subtitle: 'We build your PC exactly as you dreamed, with verified components and full warranty.',
  svc_mnt_title: 'Preventive Maintenance',
  svc_mnt_subtitle: 'Extend the lifespan of your equipment and maintain peak performance with our maintenance plans.',
  svc_sup_title: 'Tech Support',
  svc_sup_subtitle: 'We solve any hardware, software or network problem. On-site or remote, whenever you need it.',
  svc_pkg_basic: 'Basic',
  svc_pkg_pro: 'Pro',
  svc_pkg_enterprise: 'Enterprise',
  svc_pkg_deep: 'Deep Clean',
  svc_pkg_contract: 'Enterprise Contract',
  svc_pkg_remote: 'Remote',
  svc_pkg_onsite: 'On-Site',
  svc_pkg_sla: 'Monthly SLA Plan',
  svc_pkg_cta_request: 'Request',
  svc_pkg_cta_request_now: 'Request Now',
  svc_pkg_cta_request_quote: 'Request Quote',
  svc_pkg_cta_schedule: 'Schedule',
  svc_pkg_cta_schedule_now: 'Schedule Now',
  svc_pkg_cta_proposal: 'View Proposal',
  svc_pkg_cta_connect: 'Connect Now',
  svc_pkg_cta_visit: 'Schedule Visit',
  svc_pkg_cta_sla: 'Request SLA',
  svc_pkg_badge_popular: 'Popular',
  svc_pkg_badge_complete: 'Most Complete',
  svc_pkg_badge_recommended: 'Recommended',
  svc_find_us: 'Find Us',
  quote_badge: 'Quotes',
  quote_title: 'Request Your',
  quote_title_accent: 'Quote',
  quote_subtitle: "Describe your project or need and we'll respond within 24 hours with the best proposal on the market.",
  quote_why: 'Why Choose SpartechRDRD?',
  quote_b1: 'Official warranty on all products',
  quote_b2: 'Shipping throughout the Dominican Republic',
  quote_b3: 'Personalized technical advice at no cost',
  quote_b4: 'Assembly and configuration service included',
  quote_b5: 'Special plans for businesses and corporations',
  quote_direct: 'Direct contact',
  quote_form_title: 'Quote form',
  quote_name: 'Name *',
  quote_name_ph: 'Your name',
  quote_email: 'Email *',
  quote_phone: 'Phone',
  quote_company: 'Company',
  quote_company_ph: 'Your company (optional)',
  quote_type: 'Quote type *',
  quote_type_ph: 'Select...',
  quote_t1: 'Specific components',
  quote_t2: 'Custom assembly',
  quote_t3: 'Business solution',
  quote_t4: 'Technical service',
  quote_t5: 'Wholesale purchase',
  quote_budget: 'Approximate budget',
  quote_budget_ph: 'Prefer not to specify',
  quote_budget_1: 'Less than RD$20,000',
  quote_budget_2: 'RD$20,000 – RD$50,000',
  quote_budget_3: 'RD$50,000 – RD$150,000',
  quote_budget_4: 'RD$150,000 – RD$500,000',
  quote_budget_5: 'More than RD$500,000',
  quote_desc: 'Project description *',
  quote_desc_ph: 'Describe what you need: equipment, quantity, specifications, required date...',
  quote_error: 'Error sending. Please try again.',
  quote_submit: 'Request Quote',
  quote_sending: 'Sending...',
  quote_success_title: 'Quote sent!',
  quote_success_desc: 'We will get in touch with you within 24 hours with the best proposal.',
  quote_new: 'New quote',
  map_badge: 'Find Us',
  map_title: 'Visit Us in',
  map_title_accent: 'Santo Domingo Este',
  map_dir_label: 'Address',
  map_maps: 'Open in Google Maps',
  map_hours_label: 'Hours',
  map_mon_sat: 'Monday – Saturday',
  map_mon_fri: 'Monday – Friday',
  map_sat: 'Saturday',
  map_sun: 'Sunday',
  map_holidays: 'Holidays',
  map_closed: 'Closed',
  map_contact_label: 'Contact',
  custom_badge: 'Assemblies',
  custom_title: 'Customize It Your Way',
  custom_desc: 'We build the PC of your dreams with high-quality components, optimized for your style and needs.',
  custom_cta: 'Build Your PC',
  svc_asm_basic_f1: 'Component assembly',
  svc_asm_basic_f2: 'Windows / Linux installation',
  svc_asm_basic_f3: 'Basic boot test',
  svc_asm_basic_f4: '30-day labor warranty',
  svc_asm_basic_f5: '24-hour delivery',
  svc_asm_pro_f1: 'Professional assembly with cable management',
  svc_asm_pro_f2: 'Windows installation and activation',
  svc_asm_pro_f3: '2h CPU + GPU stress test',
  svc_asm_pro_f4: 'Drivers and base software installation',
  svc_asm_pro_f5: 'BIOS / XMP optimization',
  svc_asm_pro_f6: '90-day labor warranty',
  svc_asm_pro_f7: '48-hour delivery',
  svc_asm_ent_f1: 'Everything in the Pro plan',
  svc_asm_ent_f2: 'From 5 devices onwards',
  svc_asm_ent_f3: 'LAN network configuration',
  svc_asm_ent_f4: 'Inventory and labeling',
  svc_asm_ent_f5: '6-month post-installation support',
  svc_asm_ent_f6: '1-year extended warranty',
  svc_asm_ent_f7: 'Facility visit included',
  svc_mnt_basic_f1: 'External and internal cleaning',
  svc_mnt_basic_f2: 'Compressor dust blowing',
  svc_mnt_basic_f3: 'Internal connections review',
  svc_mnt_basic_f4: 'Temperature diagnostics',
  svc_mnt_basic_f5: 'Equipment status report',
  svc_mnt_deep_f1: 'Full disassembly and cleaning',
  svc_mnt_deep_f2: 'Premium thermal paste replacement',
  svc_mnt_deep_f3: 'RAM and GPU contact cleaning',
  svc_mnt_deep_f4: 'Drivers and BIOS update',
  svc_mnt_deep_f5: 'System optimization',
  svc_mnt_deep_f6: 'Post-cleaning temperature test',
  svc_mnt_deep_f7: '6-month labor warranty',
  svc_mnt_con_f1: 'Scheduled monthly maintenance',
  svc_mnt_con_f2: 'Updated hardware inventory',
  svc_mnt_con_f3: 'Priority response to failures',
  svc_mnt_con_f4: 'Monthly status reports',
  svc_mnt_con_f5: 'Upgrade recommendations',
  svc_mnt_con_f6: '20% discount on spare parts',
  svc_sup_rem_f1: 'Support via TeamViewer / AnyDesk',
  svc_sup_rem_f2: 'Software problem resolution',
  svc_sup_rem_f3: 'Virus and malware removal',
  svc_sup_rem_f4: 'Network and peripherals configuration',
  svc_sup_rem_f5: 'Hours: Monday – Saturday 9am-6pm',
  svc_sup_ons_f1: 'Technician at your location',
  svc_sup_ons_f2: 'Complete on-site diagnostics',
  svc_sup_ons_f3: 'Hardware and software repair',
  svc_sup_ons_f4: 'Includes 2 hours of work',
  svc_sup_ons_f5: 'Additional hours RD$600/h',
  svc_sup_ons_f6: 'Santo Domingo and surroundings',
  svc_sup_ons_f7: '30-day repair warranty',
  svc_sup_sla_f1: 'Unlimited remote support',
  svc_sup_sla_f2: 'On-site visits included (4/month)',
  svc_sup_sla_f3: 'Response time &lt; 2 hours',
  svc_sup_sla_f4: 'After-hours support (emergencies)',
  svc_sup_sla_f5: 'Backup and data recovery',
  svc_sup_sla_f6: 'Monthly incident report',
  alert_badge: 'Smart Alerts',
  alert_title1: 'Never Miss a',
  alert_title2: 'Deal or Price Drop',
  alert_body: 'Subscribe to our newsletter and receive the best deals directly to your email. Or set up specific alerts so we notify you when the product you want drops in price.',
  alert_f1_title: 'Weekly Newsletter',
  alert_f1_desc: 'The best deals and tech news every week',
  alert_f2_title: 'Price Alerts',
  alert_f2_desc: 'We notify you when the price drops below your target',
  alert_f3_title: 'WhatsApp Alerts',
  alert_f3_desc: 'Option to receive notifications via WhatsApp too',
  alert_f4_title: 'No Spam, Guaranteed',
  alert_f4_desc: 'We only send what you ask for, nothing else',
  alert_tab_newsletter: 'Newsletter',
  alert_tab_price: 'Price Alert',
  alert_success_title: 'Done!',
  alert_success_newsletter: "You've been added to our newsletter. You'll soon receive the best deals.",
  alert_success_alert: "Your price alert was set up. We'll notify you as soon as it drops.",
  alert_config_another: 'Set up another alert',
  alert_name: 'Name *',
  alert_wa_label: 'WhatsApp',
  alert_wa_note: '(for instant alerts)',
  alert_wa_ph: '(809) 000-0000 — Optional',
  alert_category: 'Product Category *',
  alert_category_ph: 'Select category...',
  alert_cat_1: 'GPUs / Video Cards',
  alert_cat_2: 'CPUs / Processors',
  alert_cat_3: 'RAM Memory',
  alert_cat_4: 'NVMe / SSD Storage',
  alert_cat_5: 'Gaming Monitors',
  alert_cat_6: 'Gaming Chairs',
  alert_cat_7: 'Power Supplies',
  alert_cat_8: 'Cases',
  alert_cat_9: 'Cooling Kits',
  alert_cat_10: 'Peripherals',
  alert_product: 'Specific Product',
  alert_product_ph: 'E.g.: RTX 4070 Super, Ryzen 7 7700X...',
  alert_target_price: 'Target Price (RD$)',
  alert_interests: 'Interests (optional)',
  alert_int_deals: 'Gaming Deals',
  alert_int_new: 'New Products',
  alert_int_builds: 'Custom Builds',
  alert_int_news: 'Tech News',
  alert_error: 'Error sending. Please try again.',
  alert_btn_newsletter: 'Subscribe to Newsletter',
  alert_btn_price: 'Activate Price Alert',
  alert_processing: 'Processing...',
  alert_no_spam: 'No spam. Cancel anytime.',
  book_available_today: 'Appointments available today',
  book_page_title: 'Book Your',
  book_page_highlight: 'Technical Appointment',
  book_page_body: 'Select date and time, fill out the form and a certified technician will come to your location or attend you at our store.',
  book_perk1_title: 'Flexible Hours',
  book_perk1_desc: 'Mon–Sat 9AM-6PM',
  book_perk2_title: 'At Your Location',
  book_perk2_desc: 'On-site service in SDN Este',
  book_perk3_title: 'Immediate Confirmation',
  book_perk3_desc: 'Confirmation via WhatsApp and email',
  book_perk4_title: 'Certified Technicians',
  book_perk4_desc: 'CompTIA A+ and Network+ certified',
  book_step1: 'Step 1',
  book_step1_sub: 'Choose date and time',
  book_step2: 'Step 2',
  book_step2_sub: 'Fill in your details',
  book_policy_title: 'Appointment Policy',
  book_policy_1: 'Arrive 5 minutes before your scheduled time',
  book_policy_2: 'If you need to cancel, notify us at least 2 hours in advance',
  book_policy_3: 'Initial diagnosis included in the service cost',
  book_policy_4: 'On-site service available in Santo Domingo Este',
  book_faq_section_title: 'Appointment Questions',
  book_faq_q1: 'How long is an appointment?',
  book_faq_a1: 'Appointments are 1 hour long. More complex work may require leaving the equipment at the store.',
  book_faq_q2: 'Is there a diagnostic fee?',
  book_faq_a2: 'Basic diagnosis is free with any scheduled service. You only pay for the service you authorize.',
  book_faq_q3: 'Can I cancel my appointment?',
  book_faq_a3: 'Yes, contact us via WhatsApp at least 2 hours in advance.',
  book_faq_q4: 'Do technicians bring parts to my home?',
  book_faq_a4: 'Technicians bring tools and common parts. For special parts, a second visit is coordinated.',
};
